import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60Arrow2Up = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 27.813 47.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M27.481,15.693 C27.290,15.871 27.048,15.960 26.806,15.960 C26.539,15.960 26.274,15.853 26.078,15.641 L14.892,3.530 L14.892,46.907 C14.892,47.458 14.447,47.905 13.899,47.905 C13.351,47.905 12.938,47.461 12.938,46.909 L12.938,3.495 L1.720,15.641 C1.346,16.045 0.719,16.068 0.316,15.693 C-0.085,15.318 -0.108,14.686 0.264,14.282 L13.157,0.323 C13.330,0.118 13.587,-0.011 13.899,-0.011 C14.180,-0.011 14.431,0.109 14.611,0.297 C14.616,0.302 14.622,0.303 14.627,0.308 L27.533,14.282 C27.906,14.686 27.883,15.318 27.481,15.693 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60Arrow2Up.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
